const AllGeneList = [
"AAAS",
"AACS",
"AAGAB",
"AAK1",
"AAMDC",
"AAMP",
"AARS",
"AARSD1",
"AASDHPPT",
"ABCA2",
"ABCA8",
"ABCB6",
"ABCC1",
"ABCF1",
"ABCF2",
"ABCF3",
"ABHD10",
"ABHD14B",
"ABRAXAS1",
"ACAA1",
"ACAA2",
"ACACA",
"ACAD8",
"ACAD9",
"ACADL",
"ACADM",
"ACADVL",
"ACAP2",
"ACAT1",
"ACAT2",
"ACBD3",
"ACBD6",
"ACIN1",
"ACLY",
"ACO1",
"ACO2",
"ACOT1",
"ACOT13",
"ACOT7",
"ACOT9",
"ACOX3",
"ACP1",
"ACP2",
"ACSF3",
"ACSL3",
"ACSL4",
"ACSL5",
"ACSS2",
"ACTL6A",
"ACTN1",
"ACTN4",
"ACTR3",
"ACTRT1",
"ACY1",
"ADA",
"ADAM17",
"ADAM9",
"ADAMTSL4",
"ADAR",
"ADD1",
"ADD3",
"ADH5",
"ADH7",
"ADI1",
"ADK",
"ADNP",
"ADO",
"ADPGK",
"ADRM1",
"ADSL",
"ADSS2",
"AFG3L2",
"AGA",
"AGK",
"AGL",
"AGO2",
"AGO3",
"AGPAT1",
"AGPS",
"AGRN",
"AGTRAP",
"AHNAK",
"AHNAK2",
"AHSA1",
"AICDA",
"AIDA",
"AIFM1",
"AIMP1",
"AIMP2",
"AIP",
"AK1",
"AK2",
"AK3",
"AKAP11",
"AKAP2",
"AKAP8L",
"AKAP9",
"AKR1A1",
"AKR1B1",
"AKR1C2",
"AKR1C3",
"AKR7A2",
"AKT1",
"ALAD",
"ALCAM",
"ALDH16A1",
"ALDH18A1",
"ALDH1B1",
"ALDH3A2",
"ALDH4A1",
"ALDH7A1",
"ALDH9A1",
"ALDOA",
"ALDOC",
"ALG1",
"ALYREF",
"AMPD2",
"ANAPC2",
"ANK3",
"ANKFY1",
"ANKHD1",
"ANKRD50",
"ANKS1A",
"ANLN",
"ANO6",
"ANP32A",
"ANP32B",
"ANPEP",
"ANTXR1",
"ANTXR2",
"ANXA1",
"ANXA11",
"ANXA2",
"ANXA4",
"ANXA5",
"ANXA6",
"ANXA7",
"ANXA8L1",
"AP1B1",
"AP1S2",
"AP2A1",
"AP2A2",
"AP2M1",
"AP3D1",
"AP3M1",
"APEH",
"APEX1",
"API5",
"APIP",
"APLP1",
"APMAP",
"APOBEC3G",
"APOE",
"APOL2",
"APOO",
"APOOL",
"APRT",
"APTX",
"AQR",
"ARF4",
"ARF5",
"ARFGAP2",
"ARFGAP3",
"ARFIP1",
"ARFRP1",
"ARG1",
"ARHGAP1",
"ARHGAP18",
"ARHGAP45",
"ARHGDIA",
"ARHGDIB",
"ARHGEF1",
"ARHGEF10",
"ARHGEF11",
"ARHGEF12",
"ARHGEF2",
"ARHGEF35",
"ARID1A",
"ARID1B",
"ARL1",
"ARL2BP",
"ARL6IP5",
"ARL6IP6",
"ARL8A",
"ARL8B",
"ARMC1",
"ARMC10",
"ARMC6",
"ARNT",
"ARPC1A",
"ARPC3",
"ARPC5",
"ARPIN",
"ARSA",
"AS3MT",
"ASAP1",
"ASCC1",
"ASCC2",
"ASCC3",
"ASL",
"ASNA1",
"ASNS",
"ASPH",
"ASS1",
"ATAD3A",
"ATG12",
"ATG16L1",
"ATG5",
"ATG7",
"ATG9A",
"ATIC",
"ATL2",
"ATL3",
"ATOX1",
"ATP11B",
"ATP13A1",
"ATP13A4",
"ATP1A1",
"ATP1B3",
"ATP2A2",
"ATP2B2",
"ATP2B4",
"ATP5F1A",
"ATP5F1C",
"ATP5F1D",
"ATP5IF1",
"ATP5MD",
"ATP5ME",
"ATP5MF",
"ATP5MG",
"ATP5PB",
"ATP5PD",
"ATP5PF",
"ATP5PO",
"ATP6AP1",
"ATP6AP2",
"ATP6V0A1",
"ATP6V0A2",
"ATP6V0D1",
"ATP6V1B2",
"ATP6V1D",
"ATP6V1G1",
"ATP8A1",
"ATRX",
"ATXN10",
"ATXN2L",
"AUP1",
"AZI2",
"B2M",
"B4GALT1",
"BABAM1",
"BAG2",
"BAG3",
"BAG6",
"BAIAP2",
"BAIAP2L1",
"BAK1",
"BANF1",
"BARGIN",
"BASP1",
"BAX",
"BAZ1B",
"BCAM",
"BCAP29",
"BCAP31",
"BCAR1",
"BCAR3",
"BCAT2",
"BCCIP",
"BCKDHB",
"BCL7C",
"BCLAF1",
"BCOR",
"BCR",
"BET1L",
"BICD2",
"BID",
"BIN1",
"BLVRA",
"BLVRB",
"BMP1",
"BMS1",
"BNIP1",
"BOD1L1",
"BOP1",
"BPNT1",
"BRD2",
"BRD7",
"BRF1",
"BRI3BP",
"BRIX1",
"BSG",
"BST2",
"BTF3",
"BTK",
"BZW2",
"C11orf68",
"C12orf10",
"C12orf57",
"C16orf58",
"C17orf75",
"C17orf80",
"C19orf25",
"C1D",
"C1QBP",
"C1R",
"C20orf27",
"C2CD5",
"C3",
"C4B",
"C5AR1",
"C6",
"C7orf50",
"C8orf82",
"CA12",
"CA13",
"CA2",
"CA9",
"CAAP1",
"CAB39",
"CACNA2D1",
"CACUL1",
"CACYBP",
"CAD",
"CADM3",
"CALCOCO2",
"CALD1",
"CALR",
"CALU",
"CAMK1D",
"CAMLG",
"CAND2",
"CANT1",
"CANX",
"CAP1",
"CAPG",
"CAPN1",
"CAPN2",
"CAPNS1",
"CAPRIN1",
"CAPZA1",
"CAPZA2",
"CARD16",
"CARHSP1",
"CARS",
"CARS2",
"CASP1",
"CASP2",
"CASP4",
"CASP6",
"CASP8",
"CASQ1",
"CAST",
"CAT",
"CAV1",
"CAVIN1",
"CAVIN2",
"CAVIN3",
"CBL",
"CBR1",
"CBR3",
"CBX3",
"CCAR2",
"CCDC12",
"CCDC124",
"CCDC158",
"CCDC168",
"CCDC183",
"CCDC22",
"CCDC25",
"CCDC86",
"CCDC88A",
"CCDC93",
"CCDC9B",
"CCNH",
"CCT2",
"CCT3",
"CCT4",
"CCT5",
"CCT6A",
"CCT7",
"CCT8",
"CD109",
"CD151",
"CD276",
"CD2BP2",
"CD3EAP",
"CD44",
"CD46",
"CD47",
"CD55",
"CD59",
"CD63",
"CD81",
"CD82",
"CD9",
"CD97",
"CD99",
"CDC16",
"CDC23",
"CDC37",
"CDC42",
"CDC42BPA",
"CDC5L",
"CDCP1",
"CDH13",
"CDH3",
"CDK1",
"CDK2",
"CDK5RAP3",
"CDK6",
"CDK7",
"CDKN2AIP",
"CDKN2C",
"CDS2",
"CEBPB",
"CEBPZ",
"CELF1",
"CEP170",
"CETN2",
"CFDP1",
"CFH",
"CFL1",
"CFL2",
"CGAS",
"CHAMP1",
"CHCHD2",
"CHCHD3",
"CHCHD4",
"CHCHD6",
"CHD1",
"CHD3",
"CHD4",
"CHERP",
"CHID1",
"CHMP1A",
"CHMP1B",
"CHMP2B",
"CHMP3",
"CHMP4A",
"CHMP4B",
"CHMP5",
"CHMP6",
"CHMP7",
"CHORDC1",
"CHP1",
"CHPF2",
"CHST12",
"CHTOP",
"CIAPIN1",
"CIB1",
"CIRBP",
"CISD2",
"CIT",
"CKAP4",
"CKAP5",
"CKMT1A",
"CKMT2",
"CLCA2",
"CLCC1",
"CLEC16A",
"CLIC1",
"CLIC4",
"CLINT1",
"CLIP1",
"CLIP2",
"CLN5",
"CLNS1A",
"CLPB",
"CLPP",
"CLPTM1",
"CLPTM1L",
"CLPX",
"CLTA",
"CMAS",
"CMBL",
"CMPK1",
"CMSS1",
"CMTM3",
"CMTR1",
"CNBP",
"CNDP2",
"CNIH4",
"CNN2",
"CNNM2",
"CNOT10",
"CNOT7",
"CNP",
"CNPY2",
"COA3",
"COA7",
"COASY",
"COG2",
"COG3",
"COG4",
"COL12A1",
"COL14A1",
"COL16A1",
"COL18A1",
"COL1A1",
"COL1A2",
"COL3A1",
"COL4A1",
"COL4A2",
"COL4A6",
"COL5A3",
"COL6A1",
"COL6A2",
"COL6A3",
"COL7A1",
"COLGALT1",
"COMMD10",
"COMMD3",
"COMMD4",
"COMMD7",
"COMMD9",
"COMT",
"COMTD1",
"COPA",
"COPB1",
"COPB2",
"COPE",
"COPG1",
"COPG2",
"COPS3",
"COPS4",
"COPS5",
"COPS7A",
"COPS8",
"COQ5",
"COQ7",
"CORO1C",
"CORO2A",
"CORO2B",
"CORO7",
"COTL1",
"COX15",
"COX20",
"COX4I1",
"COX5A",
"COX5B",
"COX6A1",
"COX6B1",
"COX6C",
"COX7A2",
"CPD",
"CPNE3",
"CPOX",
"CPS1",
"CPSF1",
"CPSF2",
"CPSF6",
"CPSF7",
"CPT1A",
"CPT2",
"CRABP2",
"CRBN",
"CRELD2",
"CRIP2",
"CRK",
"CRLF3",
"CROCC",
"CROT",
"CRTAP",
"CRTC3",
"CRYZ",
"CS",
"CSDE1",
"CSE1L",
"CSNK2A2",
"CSPG4",
"CSRP2",
"CST3",
"CSTA",
"CSTB",
"CSTF1",
"CSTF2",
"CSTF2T",
"CTBP1",
"CTCF",
"CTHRC1",
"CTNNA1",
"CTNNBL1",
"CTNND1",
"CTPS1",
"CTPS2",
"CTR9",
"CTSB",
"CTSC",
"CTSD",
"CTSZ",
"CTTN",
"CTU1",
"CUL2",
"CUL4B",
"CUTA",
"CUX1",
"CWC22",
"CXXC1",
"CYB5A",
"CYB5B",
"CYB5R1",
"CYB5R2",
"CYB5R3",
"CYC1",
"CYCS",
"CYFIP1",
"CYP51A1",
"CZIB",
"DAB2IP",
"DAG1",
"DAP3",
"DAPK3",
"DARS",
"DARS2",
"DAZAP1",
"DBI",
"DBN1",
"DBNL",
"DBT",
"DCAF13",
"DCK",
"DCP1A",
"DCPS",
"DCTD",
"DCTN1",
"DCTN2",
"DCTN3",
"DCTPP1",
"DCXR",
"DDAH2",
"DDB1",
"DDB2",
"DDHD2",
"DDOST",
"DDRGK1",
"DDT",
"DDX1",
"DDX17",
"DDX18",
"DDX19A",
"DDX20",
"DDX21",
"DDX23",
"DDX24",
"DDX27",
"DDX3X",
"DDX41",
"DDX42",
"DDX46",
"DDX47",
"DDX5",
"DDX54",
"DDX56",
"DDX58",
"DDX6",
"DDX60",
"DECR1",
"DEGS1",
"DEK",
"DERA",
"DFFA",
"DGKA",
"DGLUCY",
"DHCR7",
"DHRS1",
"DHRS4",
"DHRS7",
"DHRS7B",
"DHX15",
"DHX16",
"DHX29",
"DHX30",
"DHX38",
"DHX9",
"DIABLO",
"DIAPH1",
"DIAPH2",
"DIAPH3",
"DIDO1",
"DIMT1",
"DIP2C",
"DIS3",
"DISP2",
"DKC1",
"DKK3",
"DLAT",
"DLD",
"DLGAP4",
"DLST",
"DMAP1",
"DNAAF5",
"DNAH14",
"DNAH8",
"DNAJA1",
"DNAJA3",
"DNAJB12",
"DNAJB4",
"DNAJB6",
"DNAJC1",
"DNAJC10",
"DNAJC11",
"DNAJC13",
"DNAJC15",
"DNAJC17",
"DNAJC2",
"DNAJC3",
"DNAJC5",
"DNAJC7",
"DNAJC8",
"DNAJC9",
"DNM1L",
"DNMT1",
"DNPEP",
"DNPH1",
"DNTTIP1",
"DNTTIP2",
"DOCK6",
"DOP1B",
"DPAGT1",
"DPCD",
"DPF2",
"DPH1",
"DPM3",
"DPP3",
"DPP7",
"DPP9",
"DPY19L1",
"DPYD",
"DPYSL2",
"DPYSL3",
"DRG1",
"DSG2",
"DSG3",
"DSP",
"DST",
"DSTN",
"DTNBP1",
"DTYMK",
"DUS3L",
"DUSP3",
"DUT",
"DYNC1H1",
"DYNC1I2",
"DYNC1LI1",
"DYNC1LI2",
"DYNLT1",
"DYNLT3",
"EBF1",
"EBNA1BP2",
"ECE1",
"ECH1",
"ECHDC1",
"ECHDC3",
"ECHS1",
"ECI1",
"ECI2",
"ECM1",
"ECPAS",
"ECSCR",
"ECSIT",
"EDC3",
"EDC4",
"EEA1",
"EEF1A1P5",
"EEF1AKNMT",
"EEF1B2",
"EEF1D",
"EEF1E1",
"EEF1G",
"EEF2",
"EEF2K",
"EEFSEC",
"EFEMP1",
"EFNB1",
"EGFR",
"EHBP1L1",
"EHD1",
"EHD2",
"EHD3",
"EHD4",
"EHHADH",
"EHMT2",
"EIF1AD",
"EIF2A",
"EIF2AK2",
"EIF2B1",
"EIF2B2",
"EIF2B3",
"EIF2B4",
"EIF2B5",
"EIF2D",
"EIF2S1",
"EIF2S2",
"EIF2S3",
"EIF3A",
"EIF3B",
"EIF3C",
"EIF3F",
"EIF3G",
"EIF3H",
"EIF3I",
"EIF3J",
"EIF3K",
"EIF3L",
"EIF3M",
"EIF4A2",
"EIF4B",
"EIF4G1",
"EIF4G2",
"EIF5",
"EIF5B",
"EIF6",
"ELAC2",
"ELAVL1",
"ELMO2",
"ELMSAN1",
"ELOC",
"ELOVL1",
"ELP1",
"ELP2",
"ELP3",
"EMC1",
"EMC2",
"EMC3",
"EMC8",
"EMD",
"EMG1",
"EML2",
"EML3",
"EML4",
"ENAH",
"ENDOD1",
"ENG",
"ENO1",
"ENOPH1",
"ENY2",
"EOGT",
"EPB41L2",
"EPB41L3",
"EPHA2",
"EPHB4",
"EPHX1",
"EPPK1",
"EPRS",
"EPS15",
"EPS15L1",
"ERAL1",
"ERAP1",
"ERAP2",
"ERC1",
"ERCC2",
"ERCC3",
"EREG",
"ERG28",
"ERGIC3",
"ERH",
"ERLEC1",
"ERLIN1",
"ERLIN2",
"ERMP1",
"ERO1A",
"ERP29",
"ERP44",
"ESD",
"ESPN",
"ESYT1",
"ESYT2",
"ETFA",
"ETFB",
"ETFDH",
"ETHE1",
"EVL",
"EXD2",
"EXOC1",
"EXOC3",
"EXOC4",
"EXOC5",
"EXOC7",
"EXOC8",
"EXOSC10",
"EXOSC3",
"EXOSC4",
"EXOSC6",
"EXOSC7",
"EXOSC8",
"EXOSC9",
"EZR",
"F11R",
"F3",
"F8A1",
"FABP5",
"FADS3",
"FAF2",
"FAH",
"FAHD1",
"FAM107B",
"FAM114A1",
"FAM114A2",
"FAM120A",
"FAM136A",
"FAM160B1",
"FAM162A",
"FAM172A",
"FAM177A1",
"FAM234A",
"FAM3C",
"FAM49A",
"FAM49B",
"FAM91A1",
"FAM98A",
"FAM98B",
"FARSA",
"FARSB",
"FAS",
"FASN",
"FASTKD2",
"FAT1",
"FAT2",
"FBL",
"FBLIM1",
"FBLN1",
"FBN1",
"FBXL18",
"FBXO3",
"FBXO30",
"FBXO4",
"FBXW11",
"FCF1",
"FCGBP",
"FDFT1",
"FDPS",
"FDXR",
"FECH",
"FEN1",
"FERMT1",
"FEZ1",
"FGFR1OP",
"FH",
"FHL2",
"FHL3",
"FHOD1",
"FIP1L1",
"FITM2",
"FKBP10",
"FKBP11",
"FKBP15",
"FKBP1A",
"FKBP3",
"FKBP4",
"FKBP5",
"FKBP7",
"FKBP8",
"FKBP9",
"FLAD1",
"FLII",
"FLNA",
"FLNB",
"FLOT1",
"FMNL1",
"FMNL2",
"FMNL3",
"FMO3",
"FMOD",
"FN1",
"FN3KRP",
"FNBP4",
"FNDC3A",
"FOXK1",
"FRG1",
"FRYL",
"FSCN1",
"FSTL1",
"FTH1",
"FTL",
"FTO",
"FTSJ1",
"FTSJ3",
"FUBP1",
"FUBP3",
"FUCA2",
"FXR1",
"FXR2",
"FYB1",
"FYCO1",
"G3BP1",
"G3BP2",
"G6PD",
"GAA",
"GABPA",
"GADD45GIP1",
"GALE",
"GALK1",
"GALK2",
"GALNT1",
"GALNT2",
"GALNT5",
"GAMT",
"GANAB",
"GANC",
"GAPDH",
"GAPDHS",
"GAR1",
"GARS1",
"GART",
"GATAD2B",
"GATD1",
"GATD3A",
"GBA",
"GBE1",
"GBF1",
"GBP1",
"GBP2",
"GCA",
"GCLC",
"GCLM",
"GCN1",
"GCSH",
"GDAP1",
"GDI1",
"GDI2",
"GEMIN4",
"GEMIN5",
"GEMIN6",
"GET4",
"GFM1",
"GFPT1",
"GFPT2",
"GGCT",
"GGH",
"GGT5",
"GHDC",
"GHITM",
"GID8",
"GIGYF2",
"GIPC1",
"GIT2",
"GJA1",
"GLA",
"GLB1",
"GLCE",
"GLO1",
"GLOD4",
"GLRX",
"GLRX3",
"GLS",
"GLUD1",
"GM2A",
"GMFG",
"GMPPA",
"GMPR2",
"GMPS",
"GNA13",
"GNAI2",
"GNAI3",
"GNB1L",
"GNB4",
"GNG12",
"GNL1",
"GNL2",
"GNL3",
"GNPDA1",
"GNPDA2",
"GNS",
"GOLGA2",
"GOLGA3",
"GOLGA5",
"GOLGB1",
"GOLIM4",
"GOLM1",
"GOLPH3",
"GOPC",
"GOSR1",
"GOT1",
"GOT2",
"GPAA1",
"GPC1",
"GPC6",
"GPCPD1",
"GPD1L",
"GPHN",
"GPI",
"GPKOW",
"GPNMB",
"GPR108",
"GPX1",
"GPX4",
"GPX8",
"GRB10",
"GRHPR",
"GRIPAP1",
"GRK6",
"GRPEL1",
"GRSF1",
"GRWD1",
"GSDMC",
"GSDMD",
"GSDME",
"GSK3B",
"GSN",
"GSPT1",
"GSR",
"GSS",
"GSTK1",
"GSTO1",
"GSTP1",
"GSTT2B",
"GSTZ1",
"GTF2E1",
"GTF2F1",
"GTF2I",
"GTF3C1",
"GTF3C4",
"GTF3C5",
"GTPBP10",
"GTPBP4",
"GUCY1B1",
"GUK1",
"GUSB",
"GYG1",
"GYG2",
"GYS1",
"H1FX",
"H2AFV",
"H2AFX",
"H2AFY",
"H6PD",
"HACD3",
"HACL1",
"HADH",
"HADHA",
"HADHB",
"HARS",
"HAT1",
"HBB",
"HBS1L",
"HCCS",
"HCFC1",
"HDAC1",
"HDAC2",
"HDDC2",
"HDGF",
"HDGFL2",
"HDHD5",
"HEATR1",
"HEATR3",
"HEBP1",
"HEBP2",
"HECTD1",
"HELZ2",
"HERC4",
"HEXA",
"HEXB",
"HGS",
"HIBADH",
"HINT1",
"HIP1",
"HIST2H2AB",
"HIST2H3A",
"HK1",
"HK2",
"HLA-B",
"HLA-C",
"HLA-H",
"HM13",
"HMBS",
"HMCN1",
"HMGCL",
"HMGCS1",
"HMOX1",
"HMOX2",
"HNMT",
"HNRNPA0",
"HNRNPA1L2",
"HNRNPA2B1",
"HNRNPA3",
"HNRNPC",
"HNRNPD",
"HNRNPF",
"HNRNPH1",
"HNRNPH2",
"HNRNPH3",
"HNRNPL",
"HNRNPLL",
"HNRNPM",
"HNRNPR",
"HNRNPU",
"HNRNPUL2",
"HOMER1",
"HOOK3",
"HP1BP3",
"HPCAL1",
"HPF1",
"HPRT1",
"HPS6",
"HS1BP3",
"HSBP1",
"HSD17B10",
"HSD17B11",
"HSD17B12",
"HSD17B4",
"HSF1",
"HSP90AA1",
"HSP90AB2P",
"HSP90B1",
"HSPA14",
"HSPA1B",
"HSPA4",
"HSPA4L",
"HSPA5",
"HSPA6",
"HSPA8",
"HSPA9",
"HSPB1",
"HSPB11",
"HSPBP1",
"HSPD1",
"HSPE1",
"HSPG2",
"HSPH1",
"HTATSF1",
"HTRA1",
"HUWE1",
"HYOU1",
"HYPK",
"IAH1",
"IARS",
"IARS2",
"IBA57",
"ICAM1",
"ICMT",
"IDE",
"IDH1",
"IDH2",
"IDH3A",
"IDH3B",
"IDI1",
"IER3IP1",
"IFI16",
"IFI35",
"IFIT1",
"IFIT3",
"IFIT5",
"IFRD2",
"IGBP1",
"IGF2BP2",
"IGF2R",
"IGKV2-29",
"IGLV4-60",
"IGSF3",
"IKBIP",
"IKBKB",
"IKBKG",
"IL18",
"IL1A",
"IL1B",
"ILF3",
"ILK",
"ILVBL",
"IMMT",
"IMP3",
"IMPA1",
"IMPACT",
"IMPAD1",
"IMPDH1",
"IMPDH2",
"INF2",
"INIP",
"INO80",
"INPP1",
"INPP4A",
"INPP5A",
"INPP5B",
"INTS1",
"INTS12",
"INTS14",
"INTS3",
"INTS4",
"INTS5",
"INTS7",
"IPO4",
"IPO5",
"IPO8",
"IPO9",
"IQGAP1",
"IRAK2",
"IRF2BP2",
"IRGQ",
"IRX2",
"ISCU",
"ISOC2",
"ISY1",
"ITGA2",
"ITGA3",
"ITGA5",
"ITGA6",
"ITGAE",
"ITGAV",
"ITGB1",
"ITGB3",
"ITGB4",
"ITIH4",
"ITPR2",
"ITPR3",
"ITPRID2",
"IVD",
"IVNS1ABP",
"JAGN1",
"JUNB",
"KARS1",
"KCNAB2",
"KDM1A",
"KDM2A",
"KDM3B",
"KDSR",
"KHSRP",
"KIAA2013",
"KIDINS220",
"KIF13B",
"KIF1A",
"KIF2C",
"KIF3A",
"KIF5B",
"KIFBP",
"KIZ",
"KLC1",
"KLC2",
"KMT2D",
"KPNA2",
"KPNA6",
"KPNB1",
"KRI1",
"KRT18",
"KTN1",
"KYAT3",
"KYNU",
"L1CAM",
"L1RE1",
"L3HYPDH",
"LACTB",
"LAGE3",
"LAMA1",
"LAMA4",
"LAMA5",
"LAMB1",
"LAMB3",
"LAMC1",
"LAMC2",
"LAMP1",
"LAMP2",
"LAMTOR1",
"LAMTOR2",
"LANCL1",
"LANCL2",
"LAP3",
"LARP1",
"LARP4",
"LARP7",
"LARS",
"LAS1L",
"LASP1",
"LCLAT1",
"LCMT1",
"LCP1",
"LDAH",
"LDHA",
"LDHB",
"LDLR",
"LEMD2",
"LEO1",
"LETM1",
"LGALS1",
"LGALS3BP",
"LGALS7",
"LHPP",
"LIG3",
"LIG4",
"LIMA1",
"LIMD2",
"LIN7C",
"LINC00471",
"LIPA",
"LITAF",
"LIX1L",
"LMAN1",
"LMAN2",
"LMF2",
"LMNA",
"LMNB1",
"LMNB2",
"LMO7",
"LNPEP",
"LNPK",
"LONP1",
"LOXL2",
"LPCAT1",
"LPCAT2",
"LPCAT3",
"LPP",
"LPXN",
"LRBA",
"LRCH3",
"LRP1",
"LRPAP1",
"LRPPRC",
"LRRC40",
"LRRC47",
"LRRC59",
"LRRC7",
"LRRC8A",
"LRRC8C",
"LRRFIP1",
"LRRK2",
"LSG1",
"LSM2",
"LSM4",
"LSM5",
"LSS",
"LTA4H",
"LTN1",
"LUC7L2",
"LUZP1",
"LYAR",
"LYN",
"LYPLA1",
"LZIC",
"MACF1",
"MAD1L1",
"MAD2L1",
"MAGED2",
"MALT1",
"MAN2A1",
"MAN2B1",
"MANBA",
"MANF",
"MAP1B",
"MAP1S",
"MAP2K1",
"MAP2K2",
"MAP3K2",
"MAP3K20",
"MAP3K5",
"MAP3K6",
"MAP4",
"MAP4K4",
"MAPK12",
"MAPK3",
"MAPK9",
"MAPRE1",
"MARCH5",
"MARCKS",
"MARCKSL1",
"MARS",
"MAT2A",
"MAT2B",
"MATR3",
"MAVS",
"MBD1",
"MBD2",
"MBOAT7",
"MCAM",
"MCCC1",
"MCCC2",
"MCEE",
"MCM2",
"MCM3",
"MCM4",
"MCM5",
"MCM6",
"MCM7",
"MCMBP",
"MCRIP2",
"MCTS1",
"MDC1",
"MDH1",
"MDH2",
"MDN1",
"ME1",
"ME2",
"MEAF6",
"MEAK7",
"MECP2",
"MED12",
"MED14",
"MED15",
"MED4",
"MEMO1",
"MEPCE",
"MESD",
"METTL1",
"METTL14",
"METTL7A",
"MFF",
"MFN1",
"MFN2",
"MFSD10",
"MGAM",
"MGAT2",
"MGST1",
"MGST2",
"MIA2",
"MIA3",
"MICAL2",
"MICALL1",
"MICALL2",
"MICU1",
"MIF",
"MINPP1",
"MIOS",
"MKI67",
"MLEC",
"MMAB",
"MME",
"MMGT1",
"MMP1",
"MMP13",
"MMP2",
"MMS19",
"MMTAG2",
"MNAT1",
"MOB1A",
"MOB3A",
"MOB4",
"MOCS2",
"MOGS",
"MORC3",
"MORF4L2",
"MOV10",
"MPHOSPH6",
"MPI",
"MPRIP",
"MPZ",
"MPZL1",
"MRC2",
"MRGBP",
"MRPL1",
"MRPL15",
"MRPL16",
"MRPL19",
"MRPL2",
"MRPL21",
"MRPL27",
"MRPL3",
"MRPL34",
"MRPL37",
"MRPL38",
"MRPL39",
"MRPL4",
"MRPL40",
"MRPL44",
"MRPL45",
"MRPL46",
"MRPL47",
"MRPL49",
"MRPL50",
"MRPL53",
"MRPL55",
"MRPL57",
"MRPL58",
"MRPL9",
"MRPS14",
"MRPS15",
"MRPS17",
"MRPS21",
"MRPS22",
"MRPS23",
"MRPS26",
"MRPS27",
"MRPS30",
"MRPS31",
"MRPS34",
"MRPS35",
"MRPS5",
"MRPS7",
"MRPS9",
"MRRF",
"MRTO4",
"MSH2",
"MSH3",
"MSH6",
"MSL1",
"MSMO1",
"MSN",
"MSRA",
"MSRB3",
"MSTO1",
"MT-CO2",
"MT-ND2",
"MT-ND5",
"MT-ND6",
"MT1F",
"MT2A",
"MTA2",
"MTCH1",
"MTCH2",
"MTDH",
"MTFR1",
"MTHFD1",
"MTHFD1L",
"MTHFD2",
"MTHFS",
"MTMR1",
"MTMR14",
"MTMR6",
"MTMR9",
"MTOR",
"MTPAP",
"MTPN",
"MTX1",
"MTX3",
"MVD",
"MVK",
"MVP",
"MX1",
"MX2",
"MXRA7",
"MYBBP1A",
"MYCBP2",
"MYDGF",
"MYH10",
"MYH11",
"MYH2",
"MYH4",
"MYH9",
"MYL12A",
"MYLK",
"MYO18A",
"MYO1B",
"MYO1D",
"MYO1F",
"MYO3A",
"MYO6",
"MYO9B",
"MYOF",
"NAA10",
"NAA15",
"NAA25",
"NAA50",
"NAB2",
"NADK2",
"NAE1",
"NAGA",
"NAGK",
"NAMPT",
"NANS",
"NAP1L1",
"NAP1L4",
"NAPA",
"NARS1",
"NASP",
"NAT10",
"NAT2",
"NAV1",
"NAXE",
"NBAS",
"NCAM1",
"NCAPD2",
"NCAPG",
"NCAPG2",
"NCBP1",
"NCDN",
"NCEH1",
"NCKAP1",
"NCKAP1L",
"NCKIPSD",
"NCL",
"NCLN",
"NCOA5",
"NDE1",
"NDRG1",
"NDRG3",
"NDUFA10",
"NDUFA11",
"NDUFA13",
"NDUFA2",
"NDUFA4",
"NDUFA5",
"NDUFA6",
"NDUFA7",
"NDUFA8",
"NDUFA9",
"NDUFAF2",
"NDUFAF3",
"NDUFB1",
"NDUFB10",
"NDUFB11",
"NDUFB3",
"NDUFB4",
"NDUFB5",
"NDUFB6",
"NDUFB7",
"NDUFB8",
"NDUFB9",
"NDUFS1",
"NDUFS2",
"NDUFS3",
"NDUFS6",
"NDUFV1",
"NDUFV2",
"NECAP2",
"NECTIN1",
"NEDD4L",
"NEDD8",
"NEK9",
"NELFB",
"NELFCD",
"NEMF",
"NENF",
"NES",
"NF1",
"NFIA",
"NFKB1",
"NFKB2",
"NFU1",
"NFXL1",
"NHEJ1",
"NHP2",
"NIBAN1",
"NIBAN2",
"NIF3L1",
"NIN",
"NIPSNAP1",
"NIPSNAP3A",
"NIT1",
"NIT2",
"NLN",
"NLRX1",
"NME1",
"NME2P1",
"NME3",
"NMT1",
"NNMT",
"NNT",
"NOC2L",
"NOC3L",
"NOC4L",
"NOL11",
"NOL3",
"NOL6",
"NOL7",
"NOL9",
"NOLC1",
"NOM1",
"NOMO1",
"NOMO3",
"NONO",
"NOP14",
"NOP16",
"NOP2",
"NOP56",
"NOP58",
"NOP9",
"NOSIP",
"NOTCH1",
"NPC1",
"NPC2",
"NPEPL1",
"NPEPPS",
"NPLOC4",
"NPM1",
"NPM3",
"NPTN",
"NQO1",
"NQO2",
"NRBF2",
"NRBP1",
"NRDC",
"NRM",
"NRP1",
"NSDHL",
"NSF",
"NSFL1C",
"NSMCE3",
"NSUN2",
"NT5C",
"NT5DC1",
"NT5DC2",
"NT5E",
"NTMT1",
"NTPCR",
"NUB1",
"NUBP2",
"NUCB1",
"NUCB2",
"NUDC",
"NUDCD1",
"NUDCD3",
"NUDT1",
"NUDT21",
"NUDT5",
"NUFIP2",
"NUMA1",
"NUMB",
"NUP107",
"NUP133",
"NUP153",
"NUP155",
"NUP188",
"NUP205",
"NUP214",
"NUP35",
"NUP37",
"NUP43",
"NUP50",
"NUP58",
"NUP88",
"NUP93",
"NUP98",
"NXN",
"NXNL1",
"OAS2",
"OAS3",
"OAT",
"OCIAD1",
"OCIAD2",
"ODR4",
"OGDH",
"OGFR",
"OLA1",
"OLFML2A",
"OLFML3",
"OPA1",
"OPLAH",
"OPTN",
"OS9",
"OSBP",
"OSBPL11",
"OSBPL5",
"OSBPL6",
"OSBPL8",
"OSBPL9",
"OSGEP",
"OSTC",
"OSTF1",
"OTUB1",
"OTULIN",
"OXA1L",
"OXCT1",
"OXR1",
"OXSR1",
"P3H1",
"P3H2",
"P4HA1",
"P4HA2",
"P4HB",
"PA2G4",
"PABPC4",
"PACS1",
"PACSIN3",
"PAF1",
"PAFAH1B3",
"PAICS",
"PAIP1",
"PAK1",
"PAK2",
"PALLD",
"PAM16",
"PANK2",
"PAPOLA",
"PAPSS1",
"PARK7",
"PARN",
"PARP1",
"PARP4",
"PARP9",
"PARVA",
"PAXBP1",
"PAXX",
"PBDC1",
"PBK",
"PBXIP1",
"PC",
"PCBP1",
"PCCB",
"PCDH7",
"PCK2",
"PCM1",
"PCMT1",
"PCNA",
"PCNP",
"PCOLCE",
"PCYOX1",
"PCYT1A",
"PCYT2",
"PDCD10",
"PDCD11",
"PDCD5",
"PDCD6",
"PDCD6IP",
"PDCL3",
"PDE12",
"PDGFRB",
"PDHA1",
"PDHB",
"PDHX",
"PDIA3",
"PDIA4",
"PDIA5",
"PDIA6",
"PDLIM1",
"PDLIM2",
"PDLIM3",
"PDLIM4",
"PDLIM7",
"PDP1",
"PDPN",
"PDPR",
"PDS5B",
"PDXDC1",
"PDXK",
"PEBP1",
"PEF1",
"PEG10",
"PELO",
"PELP1",
"PEPD",
"PES1",
"PEX11B",
"PEX14",
"PEX19",
"PEX5",
"PFAS",
"PFDN1",
"PFDN2",
"PFDN4",
"PFDN5",
"PFKFB3",
"PFKL",
"PFKM",
"PFKP",
"PFN1",
"PGAM5",
"PGD",
"PGK1",
"PGK2",
"PGLS",
"PGM1",
"PGM2",
"PGM2L1",
"PGM3",
"PGP",
"PHAX",
"PHB",
"PHB2",
"PHC3",
"PHF5A",
"PHGDH",
"PHIP",
"PHLDB1",
"PHLDB2",
"PHPT1",
"PI4K2A",
"PI4KB",
"PICALM",
"PIEZO1",
"PIGG",
"PIGK",
"PIGO",
"PIGT",
"PIK3C2A",
"PIK3C3",
"PIK3R1",
"PIK3R2",
"PIN1",
"PITHD1",
"PITPNB",
"PITRM1",
"PKM",
"PKN1",
"PKN2",
"PKP3",
"PLAA",
"PLAU",
"PLAUR",
"PLBD2",
"PLCB3",
"PLCG1",
"PLCH2",
"PLCL1",
"PLD3",
"PLEC",
"PLEKHF1",
"PLIN3",
"PLIN4",
"PLOD1",
"PLOD2",
"PLOD3",
"PLP2",
"PLPP1",
"PLPP3",
"PLRG1",
"PLS1",
"PLS3",
"PLSCR3",
"PLXDC2",
"PLXNA1",
"PLXNB2",
"PM20D2",
"PML",
"PMM2",
"PMPCA",
"PMPCB",
"PMVK",
"PNISR",
"PNKP",
"PNN",
"PNP",
"PNPT1",
"PODXL",
"POFUT1",
"POGLUT1",
"POGLUT2",
"POLD2",
"POLDIP2",
"POLR1A",
"POLR1B",
"POLR1C",
"POLR1E",
"POLR2A",
"POLR2J",
"POLR3A",
"POM121C",
"POP1",
"POR",
"PPA1",
"PPA2",
"PPAT",
"PPCS",
"PPFIBP1",
"PPIA",
"PPIB",
"PPID",
"PPIE",
"PPIF",
"PPIH",
"PPIL1",
"PPIL3",
"PPIL4",
"PPM1F",
"PPM1G",
"PPME1",
"PPP1R12A",
"PPP1R12C",
"PPP1R13L",
"PPP1R14C",
"PPP1R18",
"PPP1R2",
"PPP1R3D",
"PPP1R7",
"PPP1R9B",
"PPP2CA",
"PPP2R1A",
"PPP2R1B",
"PPP2R5D",
"PPP3CA",
"PPP3CB",
"PPP4R2",
"PPP5C",
"PPWD1",
"PRAF2",
"PRCP",
"PRDX1",
"PRDX2",
"PRDX3",
"PRDX4",
"PRDX5",
"PRDX6",
"PREB",
"PREP",
"PRIM2",
"PRKAB1",
"PRKAR1A",
"PRKAR2A",
"PRKCD",
"PRKCH",
"PRKCSH",
"PRKDC",
"PRMT3",
"PRNP",
"PRORP",
"PRPF19",
"PRPF31",
"PRPF38A",
"PRPF4",
"PRPF40A",
"PRPF6",
"PRPS2",
"PRRC1",
"PRRC2A",
"PRRC2C",
"PRXL2A",
"PRXL2B",
"PSAP",
"PSAT1",
"PSIP1",
"PSMA1",
"PSMA3",
"PSMA4",
"PSMA6",
"PSMA7",
"PSMB1",
"PSMB2",
"PSMB3",
"PSMB6",
"PSMB7",
"PSMB8",
"PSMB9",
"PSMC2",
"PSMC4",
"PSMD1",
"PSMD10",
"PSMD11",
"PSMD12",
"PSMD13",
"PSMD2",
"PSMD3",
"PSMD4",
"PSMD5",
"PSMD6",
"PSMD8",
"PSMD9",
"PSME1",
"PSME2",
"PSME4",
"PSMG1",
"PSMG2",
"PSPC1",
"PSTPIP2",
"PTAR1",
"PTBP1",
"PTCD3",
"PTDSS2",
"PTGES",
"PTGES2",
"PTGFRN",
"PTGR1",
"PTGR2",
"PTGS2",
"PTK2",
"PTK7",
"PTP4A2",
"PTPA",
"PTPN1",
"PTPN11",
"PTPN12",
"PTPN23",
"PTPN9",
"PTPRA",
"PTRH1",
"PTRH2",
"PTRHD1",
"PTTG1IP",
"PTX3",
"PUF60",
"PUM2",
"PURB",
"PUS1",
"PUS7",
"PWP1",
"PWP2",
"PXN",
"PYCR1",
"PYCR3",
"PYGB",
"PYGO2",
"QARS",
"QDPR",
"QRICH1",
"QSOX2",
"QTRT1",
"QTRT2",
"RAB11FIP5",
"RAB13",
"RAB18",
"RAB23",
"RAB2A",
"RAB31",
"RAB32",
"RAB34",
"RAB3GAP1",
"RAB3GAP2",
"RAB5C",
"RAB6D",
"RAB8A",
"RAB8B",
"RAB9A",
"RABEP1",
"RABEP2",
"RABGGTA",
"RABGGTB",
"RAD18",
"RAD21",
"RAD23A",
"RAD23B",
"RAD50",
"RAI14",
"RALA",
"RALY",
"RANBP1",
"RANBP2",
"RANBP3",
"RANGAP1",
"RAP1GDS1",
"RAPGEF1",
"RAPH1",
"RARS",
"RARS2",
"RASA1",
"RASA3",
"RAVER1",
"RB1",
"RBBP9",
"RBFOX2",
"RBM10",
"RBM12",
"RBM14",
"RBM15",
"RBM17",
"RBM19",
"RBM22",
"RBM25",
"RBM26",
"RBM27",
"RBM28",
"RBM34",
"RBM8A",
"RBPJ",
"RBPMS",
"RCC1",
"RCC2",
"RCN1",
"RCN3",
"RDH11",
"RDH14",
"RDX",
"RECQL",
"RECQL5",
"REEP5",
"REL",
"RELA",
"RELCH",
"RETSAT",
"REXO2",
"RFC4",
"RFC5",
"RFT1",
"RFTN1",
"RGPD3",
"RHBDF2",
"RHOT1",
"RHOT2",
"RHPN2P1",
"RIC8A",
"RICTOR",
"RIN1",
"RING1",
"RMC1",
"RMDN1",
"RNASEH2A",
"RNASEH2B",
"RNASEH2C",
"RNASEL",
"RNASET2",
"RNF11",
"RNF121",
"RNF181",
"RNF185",
"RNF20",
"RNF213",
"RNH1",
"RNMT",
"RNPEP",
"RO60",
"ROCK1",
"ROCK2",
"RP2",
"RPA1",
"RPA2",
"RPAIN",
"RPAP3",
"RPE",
"RPL10A",
"RPL13",
"RPL13A",
"RPL14",
"RPL18",
"RPL18A",
"RPL21",
"RPL27A",
"RPL28",
"RPL29",
"RPL3",
"RPL35",
"RPL35A",
"RPL36",
"RPL4",
"RPL5",
"RPL6",
"RPL7",
"RPL7A",
"RPL9",
"RPLP1",
"RPN1",
"RPN2",
"RPP30",
"RPRD1A",
"RPRD1B",
"RPRD2",
"RPS10",
"RPS12",
"RPS16",
"RPS2",
"RPS27A",
"RPS27L",
"RPS3",
"RPS5",
"RPS6KA1",
"RPS6KA3",
"RPS6KA4",
"RPTOR",
"RRAD",
"RRAS",
"RRBP1",
"RRM1",
"RRM2",
"RRP1",
"RRP12",
"RRP15",
"RRP1B",
"RRP8",
"RRP9",
"RRS1",
"RSF1",
"RSL1D1",
"RSU1",
"RTCB",
"RTF1",
"RTN1",
"RTN2",
"RTN4",
"RUFY1",
"RUVBL1",
"RUVBL2",
"RWDD1",
"RXRA",
"S100A11",
"S100A13",
"S100A16",
"S100A2",
"S100A4",
"S100A6",
"S100A8",
"S100A9",
"SAAL1",
"SACS",
"SAE1",
"SAFB",
"SAFB2",
"SAMHD1",
"SAMM50",
"SAP18",
"SAP30BP",
"SAR1A",
"SAR1B",
"SARM1",
"SARS",
"SARS2",
"SART1",
"SART3",
"SASH1",
"SBDS",
"SBF1",
"SBF2",
"SCAF4",
"SCAMP1",
"SCAMP2",
"SCAMP4",
"SCARB2",
"SCCPDH",
"SCD",
"SCEL",
"SCFD1",
"SCFD2",
"SCN4B",
"SCO2",
"SCP2",
"SCRIB",
"SCRN1",
"SCYL1",
"SCYL2",
"SDC1",
"SDF4",
"SDHA",
"SDHB",
"SEC13",
"SEC14L2",
"SEC16A",
"SEC22B",
"SEC23IP",
"SEC24A",
"SEC24B",
"SEC24C",
"SEC24D",
"SEC31A",
"SEC63",
"SEH1L",
"SELENBP1",
"SELENOI",
"SELENOK",
"SELENOM",
"SELENOS",
"SELENOW",
"SEPHS1",
"SEPTIN10",
"SEPTIN11",
"SEPTIN2",
"SEPTIN9",
"SERPINB1",
"SERPINB3",
"SERPINB4",
"SERPINB5",
"SERPINB6",
"SERPINB7",
"SERPINB8",
"SERPINE1",
"SERPINE2",
"SERPING1",
"SERPINH1",
"SETD7",
"SETDB1",
"SF1",
"SF3A1",
"SF3A2",
"SF3A3",
"SF3B2",
"SF3B5",
"SF3B6",
"SFPQ",
"SFSWAP",
"SFXN1",
"SFXN3",
"SGMS1",
"SGPL1",
"SGPP1",
"SGSH",
"SGTA",
"SH3BGRL",
"SH3GL1",
"SH3GLB1",
"SH3GLB2",
"SH3KBP1",
"SH3PXD2A",
"SH3PXD2B",
"SHARPIN",
"SHC1",
"SHFL",
"SHKBP1",
"SHMT2",
"SHOC2",
"SIGLECL1",
"SIN3A",
"SIRPA",
"SIRT3",
"SKIV2L",
"SLC12A4",
"SLC12A7",
"SLC14A1",
"SLC16A1",
"SLC16A2",
"SLC16A3",
"SLC1A3",
"SLC1A5",
"SLC20A2",
"SLC25A10",
"SLC25A12",
"SLC25A13",
"SLC25A22",
"SLC25A24",
"SLC25A3",
"SLC25A4",
"SLC25A46",
"SLC25A6",
"SLC27A1",
"SLC27A4",
"SLC29A1",
"SLC2A1",
"SLC2A13",
"SLC35B1",
"SLC35B2",
"SLC37A4",
"SLC38A10",
"SLC39A10",
"SLC39A14",
"SLC39A7",
"SLC39A8",
"SLC3A2",
"SLC44A1",
"SLC6A6",
"SLC7A1",
"SLC7A5",
"SLC9A3R1",
"SLC9A3R2",
"SLC9A7",
"SLCO2A1",
"SLFN5",
"SLIRP",
"SLIT2",
"SLK",
"SMAD5",
"SMARCAD1",
"SMARCC1",
"SMARCC2",
"SMARCD1",
"SMARCD2",
"SMARCD3",
"SMARCE1",
"SMC2",
"SMC3",
"SMC4",
"SMCHD1",
"SMOC1",
"SMPD4",
"SMS",
"SMTN",
"SNAP23",
"SNAP29",
"SNCA",
"SND1",
"SNRNP200",
"SNRNP40",
"SNRNP70",
"SNRPA",
"SNRPB2",
"SNW1",
"SNX1",
"SNX12",
"SNX17",
"SNX18",
"SNX4",
"SNX5",
"SNX6",
"SNX7",
"SNX8",
"SNX9",
"SOD1",
"SOD2",
"SORBS3",
"SORD",
"SOWAHC",
"SP100",
"SPAG17",
"SPAG9",
"SPANXB1",
"SPARC",
"SPATS2L",
"SPCS1",
"SPCS2",
"SPG21",
"SPI1",
"SPIRE1",
"SPPL2A",
"SPR",
"SPTAN1",
"SPTBN1",
"SPTBN2",
"SPTLC1",
"SQLE",
"SQOR",
"SQSTM1",
"SRA1",
"SRC",
"SRFBP1",
"SRGAP2B",
"SRI",
"SRM",
"SRP14",
"SRP54",
"SRP68",
"SRP72",
"SRP9",
"SRPK1",
"SRPRA",
"SRPRB",
"SRRM2",
"SRRT",
"SRSF11",
"SRSF4",
"SRSF6",
"SRSF7",
"SRSF9",
"SRXN1",
"SSB",
"SSBP1",
"SSBP4",
"SSR3",
"SSR4",
"ST13",
"STAG2",
"STAM",
"STAMBP",
"STARD5",
"STAT1",
"STAT2",
"STAU1",
"STC1",
"STIM1",
"STIP1",
"STK10",
"STK24",
"STK26",
"STK3",
"STK39",
"STK4",
"STMN1",
"STMN2",
"STMN3",
"STOM",
"STOML2",
"STON2",
"STRAP",
"STRBP",
"STRN4",
"STT3B",
"STX10",
"STX12",
"STX16",
"STX4",
"STX7",
"STX8",
"STXBP3",
"SUB1",
"SUCLA2",
"SUCLG1",
"SUCLG2",
"SUGP2",
"SUGT1",
"SUMF1",
"SUMF2",
"SUN1",
"SUN2",
"SUPT16H",
"SUPT6H",
"SUPV3L1",
"SVIL",
"SWAP70",
"SYAP1",
"SYMPK",
"SYNCRIP",
"SYNE2",
"SYNE3",
"SYNGR2",
"SYPL1",
"SYTL1",
"TAB1",
"TACC2",
"TACO1",
"TAF15",
"TAF6",
"TAGLN",
"TAGLN2",
"TAGLN3",
"TALDO1",
"TAOK1",
"TAP1",
"TAP2",
"TAPBP",
"TARS1",
"TASOR",
"TATDN1",
"TAX1BP1",
"TAX1BP3",
"TBC1D13",
"TBC1D15",
"TBC1D17",
"TBC1D2",
"TBC1D4",
"TBC1D5",
"TBC1D9B",
"TBCA",
"TBCB",
"TBCD",
"TBCE",
"TBL1XR1",
"TBL2",
"TBL3",
"TBRG4",
"TCAF1",
"TCERG1",
"TCF20",
"TCF4",
"TCOF1",
"TCP1",
"TCP11L1",
"TDP1",
"TEX10",
"TEX264",
"TFAM",
"TFCP2",
"TFG",
"TFIP11",
"TFPI2",
"TFRC",
"TGFBI",
"TGM2",
"TGOLN2",
"THEM4",
"THOC1",
"THOC2",
"THOC3",
"THOC5",
"THOC6",
"THOP1",
"THRAP3",
"THTPA",
"THUMPD1",
"THUMPD3",
"THYN1",
"TIAL1",
"TIMM13",
"TIMM21",
"TIMM22",
"TIMM44",
"TIMM50",
"TIMM8B",
"TIMM9",
"TIMMDC1",
"TIMP1",
"TINAGL1",
"TIPRL",
"TJP2",
"TK1",
"TKFC",
"TKT",
"TLE5",
"TLN1",
"TLR2",
"TM9SF3",
"TM9SF4",
"TMBIM1",
"TMED3",
"TMED7",
"TMED9",
"TMEM106B",
"TMEM109",
"TMEM120A",
"TMEM126A",
"TMEM161A",
"TMEM164",
"TMEM165",
"TMEM173",
"TMEM192",
"TMEM199",
"TMEM205",
"TMEM209",
"TMEM214",
"TMEM245",
"TMEM259",
"TMEM30A",
"TMEM33",
"TMEM41A",
"TMEM43",
"TMEM65",
"TMEM87A",
"TMEM97",
"TMF1",
"TMLHE",
"TMOD3",
"TMTC3",
"TMUB1",
"TMX1",
"TMX2",
"TMX3",
"TNC",
"TNFAIP2",
"TNFAIP6",
"TNFRSF10B",
"TNIP1",
"TNKS1BP1",
"TNPO1",
"TNPO3",
"TNS1",
"TNS2",
"TNS3",
"TNXB",
"TOE1",
"TOLLIP",
"TOM1L2",
"TOMM22",
"TOMM34",
"TOMM40",
"TOMM5",
"TOMM70",
"TOP1",
"TOP2B",
"TOR1A",
"TOR1AIP1",
"TP53BP1",
"TP53I3",
"TP53RK",
"TP63",
"TPBG",
"TPD52",
"TPD52L2",
"TPI1",
"TPM3",
"TPM4",
"TPP1",
"TPP2",
"TPR",
"TPT1",
"TRA2A",
"TRAF1",
"TRAFD1",
"TRAM1",
"TRAP1",
"TRAPPC2B",
"TRAPPC2L",
"TRAPPC4",
"TRAPPC9",
"TRIM21",
"TRIM22",
"TRIM25",
"TRIM26",
"TRIM28",
"TRIM3",
"TRIM32",
"TRIM33",
"TRIM4",
"TRIM47",
"TRIM56",
"TRIO",
"TRIOBP",
"TRIP10",
"TRIP11",
"TRIP13",
"TRIP6",
"TRIR",
"TRMT1",
"TRMT10C",
"TRMT1L",
"TRMT5",
"TRMT6",
"TRMT61A",
"TRRAP",
"TSC2",
"TSC22D4",
"TSEN34",
"TSFM",
"TSG101",
"TSN",
"TSNAX",
"TSPO",
"TSR1",
"TSTA3",
"TTC1",
"TTC27",
"TTC37",
"TTC4",
"TTLL12",
"TTN",
"TUBA1C",
"TUBAL3",
"TUBB6",
"TUBGCP2",
"TUBGCP3",
"TUFM",
"TUT7",
"TWF1",
"TWF2",
"TWISTNB",
"TXLNA",
"TXN",
"TXN2",
"TXNDC12",
"TXNDC17",
"TXNDC5",
"TXNIP",
"TXNRD1",
"TXNRD2",
"TYMP",
"TYMS",
"U2AF1L5",
"UACA",
"UAP1",
"UAP1L1",
"UBA1",
"UBA2",
"UBA52",
"UBA6",
"UBA7",
"UBAC1",
"UBAP2L",
"UBE2C",
"UBE2D4",
"UBE2F",
"UBE2L6",
"UBE2O",
"UBE2Q1",
"UBE2Q2",
"UBE2R2",
"UBE2V1",
"UBE2Z",
"UBE4A",
"UBE4B",
"UBFD1",
"UBL4A",
"UBL7",
"UBLCP1",
"UBN1",
"UBP1",
"UBQLN2",
"UBR1",
"UBR4",
"UBR5",
"UBTF",
"UBXN1",
"UBXN4",
"UBXN6",
"UBXN7",
"UCHL3",
"UCHL5",
"UFC1",
"UFD1",
"UFL1",
"UGDH",
"UGGT1",
"UGP2",
"UMPS",
"UNC45A",
"UPF2",
"UPP1",
"UQCC1",
"UQCC2",
"UQCR10",
"UQCRB",
"UQCRC1",
"UQCRC2",
"UQCRFS1",
"UQCRHL",
"UQCRQ",
"URB1",
"UROD",
"USH1C",
"USO1",
"USP10",
"USP14",
"USP15",
"USP16",
"USP19",
"USP24",
"USP3",
"USP30",
"USP34",
"USP47",
"USP5",
"USP8",
"USP9X",
"UTP15",
"UTP20",
"UTP4",
"UTP6",
"UTRN",
"VAMP3",
"VAMP8",
"VAPA",
"VAPB",
"VARS",
"VASP",
"VAT1",
"VAV2",
"VCAN",
"VCL",
"VDAC1",
"VDAC2",
"VEZF1",
"VIM",
"VKORC1",
"VKORC1L1",
"VMA21",
"VPS11",
"VPS13C",
"VPS13D",
"VPS16",
"VPS26C",
"VPS28",
"VPS29",
"VPS33A",
"VPS35",
"VPS35L",
"VPS37B",
"VPS4B",
"VPS51",
"VPS52",
"VPS53",
"VPS8",
"VTA1",
"VTI1B",
"VWA5A",
"VWA8",
"WAPL",
"WARS",
"WARS2",
"WASH3P",
"WASHC2C",
"WASHC4",
"WASHC5",
"WBP11",
"WBP2",
"WDFY2",
"WDR1",
"WDR11",
"WDR12",
"WDR3",
"WDR36",
"WDR4",
"WDR44",
"WDR61",
"WDR70",
"WDR75",
"WDR77",
"WDR91",
"WFS1",
"WLS",
"XDH",
"XPNPEP1",
"XPO1",
"XPO4",
"XPO5",
"XPO6",
"XPO7",
"XPOT",
"XRCC5",
"XRCC6",
"XRN1",
"XRN2",
"XXYLT1",
"YARS",
"YARS2",
"YBX1",
"YBX3",
"YEATS4",
"YIF1A",
"YKT6",
"YLPM1",
"YTHDF2",
"YWHAB",
"YWHAH",
"YWHAQ",
"YWHAZ",
"ZBTB8OS",
"ZC3H14",
"ZC3H15",
"ZC3H4",
"ZC3H7A",
"ZC3H7B",
"ZC3HAV1",
"ZC3HAV1L",
"ZEB2",
"ZFP36L2",
"ZFP91",
"ZFPL1",
"ZFR",
"ZMIZ1",
"ZMPSTE24",
"ZMYND8",
"ZNF207",
"ZNF326",
"ZNF428",
"ZNF512B",
"ZNF574",
"ZNF615",
"ZNF622",
"ZNF837",
"ZNRD2",
"ZYX"
];

export default AllGeneList;